import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BillingOptionsService } from '../services/billing-options.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

  constructor(private billingOptionsService: BillingOptionsService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      headers: request.headers
          .set('X-Requested-With', 'XMLHttpRequest')
          .set('Authorization', `Bearer ${this.billingOptionsService.getToken()}`)
    });
    return next.handle(request);
  }
}
